import { shallowEqual, useSelector } from 'react-redux';
import {
    getSplitFeatures,
    isBynderScopeAllowedSelector,
    isPlatformAllowedSelector,
} from 'packages/store/user/user.selectors';
import type { ActiveSplits } from 'packages/store/user/types';
import useAccountPermissions from './accountPermissions';
import useEntityPermissions from './entityPermissions';

const isPlatformAllowedEqualityFn = (left, right) => shallowEqual(left.dep.sort(), right.dep.sort());

const useAccessRights = () => {
    const { isPlatformAllowed } = useSelector(isPlatformAllowedSelector, isPlatformAllowedEqualityFn);
    const isBynderScopeAllowedSelectorFn = useSelector(isBynderScopeAllowedSelector);
    const splitFeatures = useSelector(getSplitFeatures);
    const { isAccountRoleAssigned, isAccountActionAllowed, getAccountAssignedRole } = useAccountPermissions();
    const { isEntityActionAllowed, getIdentityRole, getIdentityRoleAllUsers } = useEntityPermissions(
        getAccountAssignedRole,
        isPlatformAllowed,
    );

    const isSplitEnabled = (split: ActiveSplits) => splitFeatures?.[split] === 'on';

    return {
        isPlatformAllowed,
        isBynderScopeAllowed: isBynderScopeAllowedSelectorFn,
        isAccountRoleAssigned,
        isAccountActionAllowed,
        getAccountAssignedRole,
        isEntityActionAllowed,
        getIdentityRole,
        getIdentityRoleAllUsers,
        isSplitEnabled,
    };
};

export default useAccessRights;
